'use client';

import * as React from 'react';
import { IconArrowLeft } from 'icon/Arrows/arrow-left';
import { useRouter } from 'next-nprogress-bar';
import { Button } from 'ui';

export function Content() {
  const router = useRouter();
  return (
    <div className="mx-auto max-w-6xl px-4">
      <section className="pb-60 pt-36">
        <p className="pb-3 text-center text-md font-semibold text-brand-700">
          404
        </p>
        <h2 className="pb-6 text-center text-display-sm font-semibold text-gray-900 sm:text-display-xl xs:text-display-md">
          We can’t find this page
        </h2>
        <p className="flex-col pb-12 text-center text-xl text-gray-600 md:flex">
          <span>
            We searched high and low, but couldn’t find what you’re looking for.
          </span>
          <span>Try buttons below or refresh the page in a minute.</span>
        </p>
        <div className="flex flex-col justify-center gap-3 xs:flex-row">
          <Button
            onClick={() => {
              router.back();
            }}
            className="group"
            variant="outline"
          >
            <IconArrowLeft className="transition group-hover:-translate-x-1" />
            Go back
          </Button>
          <Button
            onClick={() => {
              router.push('/');
            }}
          >
            Go home
          </Button>
        </div>
      </section>
    </div>
  );
}
